import React, { Component } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { FaFileAlt, FaUser, FaClock, FaShieldAlt } from "react-icons/fa";
import { axios } from "../../../HelperFunctions/axios";
import "./dashboard.css";
import actionCreater from "../../../redux/actions/actionCreater";
import DashboardLayout from "./layout/DashboardLayout";

class Dashboard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      paystubCount: 0,
      loading: true,
    };
  }

  componentDidMount() {
    this.fetchStats();
  }

  fetchStats = async () => {
    try {
      let url = process.env.REACT_APP_BACKEND_URL_LOCAL;
      if (process.env.REACT_APP_MODE === "live") {
        url = process.env.REACT_APP_FRONTEND_URL_LIVE;
      }
      const token = localStorage.getItem("tokens");
      const response = await axios.get(`${url}api/auth/get-paystubs`, {
        headers: { Authorization: `bearer ${token}` },
      });
      this.setState({
        paystubCount: Array.isArray(response.data) ? response.data.length : 0,
        loading: false,
      });
    } catch (e) {
      console.log(e);
      this.setState({ loading: false });
    }
  };

  render() {
    const { userData } = this.props;
    const { paystubCount } = this.state;
    const userName = userData?.firstName || "there";
    const memberSince = userData?.createdAt
      ? new Date(userData.createdAt).toLocaleDateString("en-US", {
          month: "long",
          year: "numeric",
        })
      : "—";
    const profileComplete =
      userData?.firstName && userData?.lastName && userData?.phoneNumber && userData?.image
        ? 100
        : userData?.firstName && userData?.lastName
        ? 60
        : 30;

    return (
      <DashboardLayout>
        <h1 className="dash-page-title">Welcome back, {userName}</h1>
        <p className="dash-page-subtitle">Here's a snapshot of your account</p>

        <div className="dash-stat-grid">
          <div className="dash-stat-card">
            <div className="dash-stat-icon">
              <FaFileAlt />
            </div>
            <div className="dash-stat-info">
              <h3>{paystubCount}</h3>
              <p>Total Paystubs</p>
            </div>
          </div>

          <div className="dash-stat-card">
            <div className="dash-stat-icon">
              <FaClock />
            </div>
            <div className="dash-stat-info">
              <h3 style={{ fontSize: 20 }}>{memberSince}</h3>
              <p>Member Since</p>
            </div>
          </div>

          <div className="dash-stat-card">
            <div className="dash-stat-icon">
              <FaUser />
            </div>
            <div className="dash-stat-info">
              <h3>{profileComplete}%</h3>
              <p>Profile Complete</p>
            </div>
          </div>

          <div className="dash-stat-card">
            <div className="dash-stat-icon">
              <FaShieldAlt />
            </div>
            <div className="dash-stat-info">
              <h3 style={{ fontSize: 16, textTransform: "capitalize" }}>
                {userData?.role || "user"}
              </h3>
              <p>Account Role</p>
            </div>
          </div>
        </div>

        <div className="dash-section-card">
          <h4>Quick Actions</h4>
          <div style={{ display: "flex", gap: 12, flexWrap: "wrap" }}>
            <Link to="/paystubs" className="btn btn-secondary">
              Create New Paystub
            </Link>
            <Link to="/dashboard/profile" className="btn btn-outline-primary">
              Edit Profile
            </Link>
            <Link to="/dashboard/paystub" className="btn btn-outline-primary">
              View All Paystubs
            </Link>
          </div>
        </div>
      </DashboardLayout>
    );
  }
}

const mapStateToProps = (state) => ({
  userData: state?.userData,
});

export default connect(mapStateToProps)(Dashboard);
